/**
 * 🚨 此文件由 CloudEnableTool 自动生成，请勿手动修改！
 * This file is auto-generated by CloudEnableTool. Do not edit manually!
 */

import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export function getSupabaseUrl(): string {
  // Supabase URL 需要包含 /sb-api 前缀，用于代理路由
  // 生产环境：MEOO_CONFIG.meoo_app_access_url 已包含完整路径
  // 开发环境：使用 localhost:3015/sb-api，由 webpack devServer 代理
  return `${(window as any).MEOO_CONFIG?.meoo_app_access_url || location.origin}/sb-api`;
}

export const supabaseUrl = getSupabaseUrl();
export const supabaseAnonKey = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzc2NzgxODcwLCJleHAiOjEzMjg3NDIxODcwfQ.-jG57lqOSF_DXEiKpYA13tLac38XZqg8kB77GO_zTyY';

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
